// footer.js

scsHeaderJQuery(function($) {
	// toggle high contrast mode
	$(".scs-pagefooter .scs-accessibility-mode").on("click", function(event) {
		if (scsHeaderJQuery.cookie("scs-accessibility-mode") === "true") {
			SCS.ecommerce.setCookieForAllLanguages("scs-accessibility-mode", "false");
			$("body").removeClass("scs-accessibility-mode");
		} else {
			SCS.ecommerce.setCookieForAllLanguages("scs-accessibility-mode", "true");
			$("body").addClass("scs-accessibility-mode");
		}
		event.preventDefault();
	});
	// enable or disable high contrast mode, based on cookie state
	if (scsHeaderJQuery.cookie("scs-accessibility-mode") === "true") {
		$("body").addClass("scs-accessibility-mode");
	} else {
		$("body").removeClass("scs-accessibility-mode");
	}
	// load footer via AJAX
	// TODO: Remove after all pages are migrated to NPE header/footer
	var footer = $("#scs-pageheader-pagefooter-content .mdd-content");
	if(footer && footer.data('url')){
		footer.load( footer.data('url'), function(){
			// since footer is asynchronously loaded, stage need to be adjusted here
			// to allow proper aligning of bottom aligned background images.
			var stageBackground = $('.scs-stage-flat');
			if( stageBackground.hasClass('full-height-background') ) {
				stageBackground.css( 'bottom', $("#scs-pageheader-pagefooter-content").height() );
			}
		});
	}
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/footer.js
// module id = 36
// module chunks = 0